import { Toast } from "@sscs/ui";
import { apiErrorToast } from "Utils";
import { useRevokeAllPersonalAccessTokensMutation } from "../services/personalAccessTokens.api";

type UseRevokeAllAccessTokens = {
  handleRevokeAllAccessTokens: () => void;
};

type UseRevokeAllAccessTokenProps = {
  userId?: string;
  onClose: () => void;
};

const useRevokeAllAccessToken = ({
  userId,
  onClose,
}: UseRevokeAllAccessTokenProps): UseRevokeAllAccessTokens => {
  const [revokeAllAccessTokens] = useRevokeAllPersonalAccessTokensMutation();

  const handleRevokeAllAccessTokens = async () => {
    try {
      if (userId) {
        await revokeAllAccessTokens({
          userId,
        }).unwrap();
      }
    } catch (error) {
      apiErrorToast(error, "Could not revoke all personal access tokens");
      return;
    } finally {
      onClose();
    }

    Toast.show({
      title: "All personal access tokens revoked",
      type: "success",
    });
  };

  return {
    handleRevokeAllAccessTokens,
  };
};

export default useRevokeAllAccessToken;
